import React from "react";
import { Button,  } from "antd";
import { Colors } from "../../../theme";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { gaEvent } from "../../../analytics/analytics";
import * as GA from "../../../constants/analytics";
import DashboardCard from "./Card";
import Prospects from "../../../assets/images/Prospects.svg";

export default function ProspectCard({ allowed }) {
  const history = useHistory();
  const ProspectCard = styled.div`
  .card {
    margin-right: 1rem;
    min-height: 25em;

    margin-top: 0.5rem;
    padding: 1rem;
    border-radius: 0.5rem;
    &:hover {
      background: #edf3fa;
      cursor: pointer;
    }
    @media (max-width: 400px) {
      padding: 0rem;
    }
  }
  cursor: pointer;
  .icon {
    /* margin-top:1em; */
  }
`;
  const handleClick = () => {
    if (allowed) {
        history.push("/prospects");
       
    }
  };
  return (
    // <Tooltip
    //   trigger="hover"
    //   // visible={!allowed}
    //   title={!allowed && "You don’t have permission to view all catalogues"}
    // >
      <ProspectCard>
        <DashboardCard
          allowed={allowed}
          onClick={handleClick}
          icon={
            <img
              src={Prospects}
              alt="Prospects"
              height={"64px"}
              width={"64px"}
            />
          }
          title="Prospects"
          subTitle=" You can maintain a list of all your prospects from the recommendations"
          cta={
            <Button
              size="large"
              type={"link"}
              // disabled={!allowed}
              style={{padding:0}}
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.CREATE_COLLECTION,
                  GA.DESCRIPTION.CREATE_COLLECTION_BUTTON
                );
              }}
            >
               See all prospects
            </Button>
          }
        />
      </ProspectCard>
    // </Tooltip>
  );
}
